import './index.css';
import { SyntheticEvent, useState } from 'react';
import TransactionHistoryWeb from './index_web';
import TransactionHistoryMWeb from './index_mWeb';
import { isSmartPhone } from '../../../utilities/helper';
import { useLink } from 'react-router-stack';

const TransactionHistory = () => {
  const [routes] = useState([
    { key: 'Deposits', title: 'Deposits' },
    { key: 'Withdrawals', title: 'Withdrawals' },
    { key: 'Games', title: 'Games' },
    { key: 'Poker', title: 'Poker' },
    { key: 'Earnings', title: 'Earnings' }
  ]);
  const navigate = useLink();
  const [activeTab, setActiveTab] = useState(0);

  const onChangeTab = (_event: SyntheticEvent, activeTab: number) => {
    setActiveTab(activeTab);
  };
  const onChangeIndex = (index = 0) => {
    setActiveTab(index);
  };

  const onClickBack = () => {
    try {
      navigate.goBackView();
    } catch (err) {
      navigate.go(-1);
    }
  };

  return (
    <>
      {!isSmartPhone ? (
        <TransactionHistoryWeb
          activeTab={activeTab}
          onChangeTab={onChangeTab}
          routes={routes}
          onChangeIndex={onChangeIndex}
        />
      ) : (
        <TransactionHistoryMWeb
          routes={routes}
          activeTab={activeTab}
          onChangeTab={onChangeTab}
          onChangeIndex={onChangeIndex}
          onClickBack={onClickBack}
        />
      )}
    </>
  );
};
export default TransactionHistory;
